export { default } from "./ProductPricingV2Mspa";
